// Configuração do serviço de API

import axios from 'axios';
import { API_URL } from '../config/api';

// Garantir que a baseURL está configurada corretamente
// Preferir o mesmo host do frontend em produção para evitar problemas de CORS e hosts incorretos
let baseURL = API_URL || (typeof window !== 'undefined' ? window.location.origin : 'http://localhost:3000');

// Se a baseURL não termina com /api, adicionar
if (!baseURL.endsWith('/api')) {
  baseURL = `${baseURL}/api`;
}
console.log('baseURL ajustada para API:', baseURL);

const api = axios.create({
  baseURL: baseURL,
  timeout: 30000 // 30 segundos
});

// Interceptor para adicionar o token em todas as requisições
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('@SenhasApp:token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // console.log(`[API] Requisição ${config.method?.toUpperCase()} para ${config.url}`, 
    //   config.params ? `params: ${JSON.stringify(config.params)}` : '');
    return config;
  },
  (error) => {
    console.error('[API] Erro na requisição:', error);
    return Promise.reject(error);
  }
);

// Interceptor para tratar respostas
api.interceptors.response.use(
  (response) => {
    // console.log(`[API] Resposta de ${response.config.url}:`, 
    //   response.status, 
    //   response.data && response.data.success !== undefined ? 
    //     `success: ${response.data.success}` : '');
    
    // if (response.data && response.data.data && Array.isArray(response.data.data)) {
    //   console.log(`[API] Dados recebidos: ${response.data.data.length} itens`);
    // }
    
    return response;
  },
  (error) => {
    console.error('[API] Erro na resposta:', 
      error.response ? 
        `Status: ${error.response.status}, Mensagem: ${error.response.data?.message || error.message}` 
        : error.message);
    if (error.response?.status === 401) {
      localStorage.removeItem('@SenhasApp:token');
      localStorage.removeItem('@SenhasApp:user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api; 